import React, { useState } from 'react';
import { ClientSideTable } from 'src/components/ClientSideTable';
import {
  Alert,
  Box,
  Button,
  Modal,
  SpaceBetween,
} from '@cloudscape-design/components';

interface FeatureSelectProps {
  featureList: string[];
  setSelectedFeatures: (selectedFeatures: string[]) => void;
}

export const FeatureSelect = ({
  featureList,
  setSelectedFeatures,
}: FeatureSelectProps) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = React.useState<any>([]);

  return (
    <>
      {modalVisible && (
        <Modal
          onDismiss={() => setModalVisible(false)}
          visible={true}
          header="Select Features"
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={() => setModalVisible(false)}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    setSelectedFeatures(
                      selectedItems.reduce(
                        (prev: string[], curr: { name: string }) => {
                          prev.push(curr['name']);
                          return prev;
                        },
                        [],
                      ),
                    );
                    setModalVisible(false);
                  }}
                >
                  Submit
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <div>
            {selectedItems.length > 5 && (
              <Alert type="info">
                Selecting more than 5 features will cause the charts to not be
                rendered. However, the job table will render with any number of
                features.
              </Alert>
            )}
            <ClientSideTable
              onSelectionChange={({ detail }) => {
                setSelectedItems(detail.selectedItems);
              }}
              selectedItems={selectedItems}
              selectionType="multi"
              trackBy="name"
              columnDefinitions={[
                {
                  header: 'Feature Name',
                  id: 'feature-name',
                  cell: (item) => item.name,
                  sortingField: 'feature-name',
                  isRowHeader: true,
                },
              ]}
              data={featureList.map((feature) => ({ name: feature }))}
              title={'Features'}
              error={null}
            />
          </div>
        </Modal>
      )}
      <Button variant="normal" onClick={() => setModalVisible(true)}>
        Select Features
      </Button>
    </>
  );
};
